
define('text!_filter.html',[],function () { return '<input ng-model="search" placeholder="{{placeholder}}">\n<ul ng-show="results.length" class="results">\n  <li\n    ng-repeat="item in results"\n    ng-click="selectItem(item)"\n    ng-class="{ selected: $index == selectedIndex }"\n  >\n    {{item.neighborhood}}, {{item.city}}\n  </li>\n</ul>';});

